import { render, staticRenderFns } from "./WarehouseTransfer.vue?vue&type=template&id=0b6fec1e&scoped=true"
import script from "./WarehouseTransfer.vue?vue&type=script&lang=js"
export * from "./WarehouseTransfer.vue?vue&type=script&lang=js"
import style0 from "./WarehouseTransfer.vue?vue&type=style&index=0&id=0b6fec1e&prod&scoped=true&lang=css"
import style1 from "./WarehouseTransfer.vue?vue&type=style&index=1&id=0b6fec1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6fec1e",
  null
  
)

export default component.exports